import { ResponsiveLine } from '@nivo/line';
import React from 'react';
import { getLlmScores } from 'selectors/envelopes';
import { useSelector } from 'store';
import { buildScoreHistogramData } from 'utils/dashboard';

const RiskHistogram: React.FC = () => {
  const scoresData = useSelector(getLlmScores);

  if (!scoresData) return null;

  const processedData = buildScoreHistogramData(scoresData.buckets);

  return (
    <div className="h-full w-full flex flex-col">
      <ResponsiveLine /* or Line for fixed dimensions */
        data={[processedData]}
        margin={{ top: 10, right: 0, bottom: 0, left: 0 }}
        yScale={{ type: 'linear', min: 'auto', max: 'auto', reverse: false }}
        enablePoints={false}
        enableGridX={false}
        enableGridY={false}
        colors={['#70CEA1']}
        curve="basis"
        lineWidth={1}
      />
    </div>
  );
};

export default RiskHistogram;
